import { BrandLogo } from "@buildpy/ui/brand-logo";
import Banner from "@buildpy/ui/banner";
import SectionCard from "@buildpy/ui/section-card";
import { Link } from "@/lib/nav";
import { FORGOT_PASSWORD_PATH, SIGNUP_CTA } from "@/modules/plan/copy";
import { RESET_DONE_TEXT, RESET_LOCAL_ONLY_TEXT, type ResetNotice } from "../reset-password/reset-form-state";
import LoginForm from "./login-form";

// 로그인 — 이미 들어와 있으면 route beforeLoad 가 /app(또는 ?next=)으로 · 계정만 있고 멤버가 없으면 /onboarding 으로 보낸다 · 비밀번호를 바꾸고 왔으면(?reset=) 안내를 남긴다.
const LoginPage = ({ next, reset }: { next?: string; reset?: ResetNotice }) => {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <SectionCard as="div" className="flex w-full max-w-sm flex-col gap-y-6" padding="lg">
        <div className="flex flex-col gap-y-3">
          <h1 className="flex">
            <BrandLogo size="lg" />
          </h1>
          <p className="text-sm text-muted-foreground">
            받으신 이메일과 비밀번호로 들어오세요.
          </p>
        </div>

        {reset && (
          <div className="flex flex-col gap-y-2" data-testid="login-reset-notice">
            <p className="text-sm text-secondary-foreground" role="status">
              {RESET_DONE_TEXT}
            </p>
            {reset === "local" && <Banner tone="warning">{RESET_LOCAL_ONLY_TEXT}</Banner>}
          </div>
        )}

        <LoginForm next={next} />

        <p className="text-sm text-muted-foreground" data-testid="login-forgot">
          <Link className="font-medium text-primary underline underline-offset-4 hover:text-foreground" href={FORGOT_PASSWORD_PATH}>
            비밀번호를 잊으셨나요?
          </Link>
        </p>

        <p className="text-sm text-muted-foreground" data-testid="login-signup">
          계정이 없으신가요?{" "}
          <Link className="font-medium text-primary underline underline-offset-4 hover:text-foreground" href={SIGNUP_CTA.href}>
            {SIGNUP_CTA.label}
          </Link>
        </p>

        <p className="text-xs text-muted-foreground">
          초대받은 멤버는 받은 초대 링크로 계정을 만듭니다.
        </p>
      </SectionCard>
    </main>
  );
};

export default LoginPage;
